
export const UrlValidator = (URL: string) => {
    const regex = new RegExp('^(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
    return regex.test(URL);
};

export const ProviderNameValidator = (providerName: string) => {
    const regex = new RegExp('^[\\w._:/-]+$', 'i');
    return regex.test(providerName);
};
